export default __webpack_public_path__ + "static/assets/e3aff6a2d77481de5ea3df9fae057e39.png";